module.exports = __webpack_public_path__ + "html/project-buttons_27d0ea0d9cdcb9d23b06b6ddf41311ac.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-buttons.html
// module id = vhpm
// module chunks = 154